import es from './es';
import ca from './ca';

export default {
  es,
  ca
}
